import { render } from "./FileLoader.vue?vue&type=template&id=688549aa&scoped=true"
import script from "./FileLoader.vue?vue&type=script&lang=js"
export * from "./FileLoader.vue?vue&type=script&lang=js"

import "./FileLoader.vue?vue&type=style&index=0&id=688549aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688549aa"]])

export default __exports__